import { render, staticRenderFns } from "./DealCard.vue?vue&type=template&id=e59553c0&"
import script from "./DealCard.vue?vue&type=script&lang=js&"
export * from "./DealCard.vue?vue&type=script&lang=js&"
import style0 from "./DealCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports